<template>
  <div class="news-item">
    <div class="news-actions">
      <el-button
        type="primary"
        icon="el-icon-back"
        @click="handleReturn"
        class="return-button"
      >
        返回
      </el-button>
    </div>
    <div class="news-header">
      <h2 class="news-title">{{ data.title }}</h2>
      <div class="news-time">
        <i class="el-icon-time"></i>
        <span>{{ formatTime(data.time) }}</span>
      </div>
    </div>

    <div class="news-content">
      <div
        class="news-text"
        v-for="(paragraph, index) in data.text"
        :key="index"
      >
        <p>{{ paragraph }}</p>
      </div>

      <div class="news-image" v-if="data.images">
        <el-image
          :src="data.images"
          :preview-src-list="[data.images]"
          fit="cover"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsItem",
  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.title && value.time && Array.isArray(value.text);
      },
    },
  },
  methods: {
    formatTime(timeString) {
      if (!timeString) return "";
      return timeString.split(" ")[0];
    },
    handleReturn() {
      this.$emit("return");
    },
  },
};
</script>

<style scoped>
.news-item {
  margin-bottom: 10px;
  padding: 20px;
  background-color: #ededed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  /* height: 100vh; 或者设置固定高度如800px */
}

.news-actions {
  margin-bottom: 10px;
}

.return-button {
  margin-bottom: 10px;
}

.news-header {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.news-title {
  margin: 0;
  font-size: 20px;
  color: #303133;
}

.news-time {
  margin-top: 10px;
  font-size: 14px;
  color: #909399;
}

.news-time i {
  margin-right: 5px;
}

.news-content {
  flex: 1; /* 占据剩余空间 */
  overflow-y: auto; /* 添加垂直滚动条 */
  padding-right: 8px; /* 防止滚动条遮挡内容 */
}

.news-text {
  margin-bottom: 15px;
  line-height: 1.6;
  color: #606266;
  text-align: justify;
}

.news-text > p {
  text-indent: 2em;
  line-height: 2em;
}

.news-text:last-child {
  margin-bottom: 0;
}

.news-image {
  margin-top: 10px;
  text-align: center;
}

.news-image .el-image {
  width: 100%;
  max-width: 600px;
  border-radius: 4px;
}

/* 自定义滚动条样式 */
.news-content::-webkit-scrollbar {
  width: 6px;
}
.news-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.news-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.news-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>